__turbopack_context__.v({
  "attributeWrapperSidebar": "VehicleAttributes-module__pBS7_q__attributeWrapperSidebar",
  "contact": "VehicleAttributes-module__pBS7_q__contact",
  "depositContribution": "VehicleAttributes-module__pBS7_q__depositContribution",
  "discountAndScrolled": "VehicleAttributes-module__pBS7_q__discountAndScrolled",
  "financeDetails": "VehicleAttributes-module__pBS7_q__financeDetails",
  "inlineVAT": "VehicleAttributes-module__pBS7_q__inlineVAT",
  "logo": "VehicleAttributes-module__pBS7_q__logo",
  "makeModelNameWrapper": "VehicleAttributes-module__pBS7_q__makeModelNameWrapper",
  "monthlyPrice": "VehicleAttributes-module__pBS7_q__monthlyPrice",
  "priceAttributes": "VehicleAttributes-module__pBS7_q__priceAttributes",
  "priceWrapper": "VehicleAttributes-module__pBS7_q__priceWrapper",
  "scrollWrapper": "VehicleAttributes-module__pBS7_q__scrollWrapper",
  "smallPrint": "VehicleAttributes-module__pBS7_q__smallPrint",
  "totalPrice": "VehicleAttributes-module__pBS7_q__totalPrice",
  "vehiclePrettyName": "VehicleAttributes-module__pBS7_q__vehiclePrettyName",
  "vehicleVariantName": "VehicleAttributes-module__pBS7_q__vehicleVariantName",
});
